<div class="d-flex flex-column spacing-8" [class.centered]="align === 'center'">
  <h1 class="h1-headers primary-100 m-0">{{ title }}</h1>
  <div class="h4-reg primary-60">
    <ng-content></ng-content>
  </div>
</div>
